import ajax from '../ajax'

// https://test.vimiuvr.com/   //日常使用

// url = 'https://test.vimiuvr.com'   //打包线上
export function  IndexApi(params) {
    return ajax({
        method:'get',
        url: '/manage/index',
        params
    })
}




export function EditApi(data) {
  return ajax({
      method: 'POST',
      url: '/manage/edit',
      data
  })
}


export function DelApi(data) {
  return ajax({
      method: 'POST',
      url: '/manage/del',
      data
  })
}



// WEBPACK FOOTER //
// ./src/api/work/index.js